/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `one_d` - one_d
 * * `two_d` - two_d
 * @export
 */
export const DimensionEnum = {
  ONE_D: "one_d",
  TWO_D: "two_d",
} as const;
export type DimensionEnum = (typeof DimensionEnum)[keyof typeof DimensionEnum];

export function instanceOfDimensionEnum(value: any): boolean {
  for (const key in DimensionEnum) {
    if (Object.prototype.hasOwnProperty.call(DimensionEnum, key)) {
      if (DimensionEnum[key as keyof typeof DimensionEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function DimensionEnumFromJSON(json: any): DimensionEnum {
  return DimensionEnumFromJSONTyped(json, false);
}

export function DimensionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DimensionEnum {
  return json as DimensionEnum;
}

export function DimensionEnumToJSON(value?: DimensionEnum | null): any {
  return value as any;
}

export function DimensionEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DimensionEnum {
  return value as DimensionEnum;
}
